import { Organization } from '@/shared/api/protocol-ts/model/dto_organization_pb';

type Params = {
  current?: Organization;
  incoming: Organization;
  newestOnly?: boolean;
};

export const mergeOrganization = ({
  current,
  incoming,
  newestOnly = false,
}: Params): Organization => {
  const currentRevision = current?.Revision?.Number ?? 0;
  const incomingRevision = incoming.Revision?.Number ?? 0;

  if (newestOnly && current && incomingRevision < currentRevision) {
    return current;
  }

  // Staff changes do not advance the organization revision, so actor-specific
  // fields are taken from a same-revision update. Only MyDataStream supplies
  // MFARequiredForActor.
  const organization =
    newestOnly && current && incomingRevision === currentRevision
      ? current.clone()
      : incoming.clone();

  organization.MFARequiredForActor =
    incoming.MFARequiredForActor ?? current?.MFARequiredForActor;
  organization.YourPermissions = incoming.YourPermissions;

  return organization;
};
